<template>
  <div class="pa-2">
    <h1 class="text-center font-weight-bold">منافذنا في المحافظات</h1>
    <v-card
      class="my-4 px-3 py-3 bordered d-flex align-center flex-wrap"
      style="border-radius: 10px;!important; border-color: rgba(0,0,0, .12)!important;
        gap: 10px;
        "
      v-ripple="{ class: 'ripple--color' }"
    >
      <v-btn
        class="white--text  font-weight-bold "
        min-width="90px"
        depressed
        large
        color="black"
        v-for="(city, index) in cities"
        :key="index"
        @click="filterByCity(city)"
        :class="{ primary: selectedCity === city }"
      >
        {{ city }}
      </v-btn>
    </v-card>
    <div>
      <v-row
      >
        <v-col
          cols="12"
          md="6"
          lg="4"
          v-for="(cityAddress, index) in addresses"
          :key="index"
        >
          <v-card
            class="px-3 py-3  bordered  d-flex align-center flex-wrap "
            style="border-radius: 10px;!important; border-color: rgba(0,0,0, .12)!important;
            gap: 10px;
            "
            depressed
            v-ripple="{ class: 'ripple--color' }"
            :key="index"
          >
            <div class="d-flex flex-column align-center">
              <div
                class="strong-text--text font-weight-semibold  d-flex"
                style="font-size: 18px; gap:10px;"
              >
                <div class="d-flex-column">
                  <p>
                     اسم مركز :
                  </p>
                  <p>
                     رقم اتواصل :
                  </p>
                  <p>
                    العنوان  :
                  </p>
                </div>

                <div
                  class="d-flex-column text-caption"
                >
                  <p>
                    {{ cityAddress.cityName }}
                  </p>
                  <p>
                    {{ cityAddress.address }}
                  </p>
                  <p>
                    {{ cityAddress.num }}
                  </p>
                </div>
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      cities: [
        "القاهره",
        "الجيزه",
        "المنصوره",
        "الاسكندريه",
        "المنصوره",
      ],
      selectedCity: "القاهره",
      citiesAddresses :[
        {
            cityName: "القاهره",
            address: "القاهره القاهره القاهره القاهره",
            num : '01000000000',
            name : 'اسم مركز'
        },
        {
            cityName: "الجيزه",
            address: "الجيزه الجيزه الجيزه الجيزه",
            num : '01000000000',
            name : 'اسم مركز'
        },
        {
            cityName: "المنصوره",
            address: "المنصوره المنصوره المنصوره المنصوره",
            num : '01000000000',
            name : 'اسم مركز'
        },
        {
            cityName: "الاسماعيليه",
            address: "الاسماعيليه الاسماعيليه الاسماعيليه الاسماعيليه",
            num : '01000000000',
            name : 'اسم مركز'
        },
        {
            cityName: "الاسكندريه",
            address: "الاسكندريه الاسكندريه الاسكندريه الاسكندريه",
            num : '01000000000',
            name : 'اسم مركز'
        }
      ],
      addresses: [],
    };
  },
  methods: {
    filterByCity(city) {
      this.selectedCity = city;
      this.addresses = this.citiesAddresses.filter(
        (cityAddress) => cityAddress.cityName === city
      );
    },

  },
  mounted() {
    console.log("mounted" , this.selectedCity);
    this.addresses = this.citiesAddresses.filter(
      (cityAddress) => cityAddress.cityName === this.selectedCity
    );
  },
};
</script>
